module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-print-button",
      "title": "Stampa"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d35000c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Print.vue
// module id = 892
// module chunks = 39